/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerFragmentDoc } from '../../../pages/SettingsPage/SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UseNavigationLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type UseNavigationLinksQuery = { viewer: { hasLineActivationProvider: boolean }, planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null, uiControl: { viewBranchReport: boolean, viewCorporationReport: boolean, useLineMessageFeatures: boolean, viewMatchedRooms: boolean, viewBranchMemberRooms: boolean, viewCorporationMemberRooms: boolean } };


export const UseNavigationLinksDocument = gql`
    query useNavigationLinks {
  viewer {
    hasLineActivationProvider
  }
  planner {
    ...SettingsPagePlanner
  }
  uiControl {
    viewBranchReport
    viewCorporationReport
    useLineMessageFeatures
    viewMatchedRooms
    viewBranchMemberRooms
    viewCorporationMemberRooms
  }
}
    ${SettingsPagePlannerFragmentDoc}`;

/**
 * __useUseNavigationLinksQuery__
 *
 * To run a query within a Vue component, call `useUseNavigationLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseNavigationLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUseNavigationLinksQuery();
 */
export function useUseNavigationLinksQuery(options: VueApolloComposable.UseQueryOptions<UseNavigationLinksQuery, UseNavigationLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>(UseNavigationLinksDocument, {}, options);
}
export function useUseNavigationLinksLazyQuery(options: VueApolloComposable.UseQueryOptions<UseNavigationLinksQuery, UseNavigationLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>(UseNavigationLinksDocument, {}, options);
}
export type UseNavigationLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UseNavigationLinksQuery, UseNavigationLinksQueryVariables>;